<template>
      <div class="address-management">
        <el-button size="mini" type="success" style="display:block;margin:10px auto;" @click="addAddress(0, {})">新增收货地址</el-button>
        <p v-if="addresses.length == 0" style="color:#999;padding:30px 0;text-align:center;">暂无收货地址...</p>
        <div v-else v-for="(item,index) in addresses " :key="index" :class="{'addresslist':true, 'isChange': changetype=='0' || changetype=='1', 'curChange': addressId==item.pkid}" @click.stop="chooseThis(item)">
            <div class="isDefault"  v-if="item.isdefault">默认地址</div>
            <div style="line-height:36px ; display: flex; ">
                <div style="width: 100px; text-align: right; color:#a4a4b3;">收货人: </div>
                <div style="color: #333; margin-left: 5px;">{{item.username}}</div>
            </div>
            <div style="line-height:36px;display: flex;">
                <div style="width: 100px; text-align: right; color:#a4a4b3;">所在地区: </div>
                <div style="color: #333; margin-left: 5px;">{{ item.sheng}} {{item.shi}} {{item.qu}}</div>
            </div>
            <div style="line-height:36px ;  display: flex;">
                <div style="width: 100px; text-align: right; color:#a4a4b3;">详细地址: </div>
                <div style="color: #333; margin-left: 5px;">{{item.address}}</div>
            </div>
            <div style="line-height:36px ;  display: flex;">
                <div style="width: 100px; text-align: right; color:#a4a4b3;">手机号: </div>
                <div style="color: #333; margin-left: 5px;">{{item.mobile}}</div>
            </div>
            <div style="position: absolute; bottom: 10px; right: 10px; display: flex; align-items: center; justify-content: space-around; color: #007bff;">
                <div style="color:#ff8800;cursor: pointer;" v-if="!item.isdefault" @click.stop="setDefault(item)">设为默认</div>
                <div style="margin:0 5px;color:#33c539;cursor: pointer;" @click.stop="updateAddress(item)">编辑</div>
                <div style="color:#ff2b2b;cursor: pointer;" @click.stop="removeAddress(item)">删除</div>
            </div>
        </div>
        <!-- 收货地址新增 -->
        <!-- <el-dialog :title="type==0?'新增收货地址':'修改收货地址'" :visible.sync="dialogVisible" width="500px" :destroy-on-close="true" :before-close="handleClose">
           <div class="address-form" style="margin: 50px auto;">
            <el-form @submit.prevent="submitAddress" :model="form" :rules="rules" ref="form" label-width="100px">
              <el-form-item label="用户名" prop="username">
                <el-input v-model="form.username" placeholder="请输入用户名"></el-input>
              </el-form-item>
              <el-form-item label="手机号：" prop="mobile">
                <el-input v-model="form.mobile" placeholder="请输入手机号"></el-input>
              </el-form-item>
              <el-form-item label="省市区：" prop="selectedOptions">
                <el-cascader size="medium " :options="pcaTextArr" v-model="form.selectedOptions"> </el-cascader>
              </el-form-item>
              <el-form-item label="详细地址：" prop="address">
                  <el-input type="textarea" placeholder="请输入详细地址" v-model="form.address"></el-input>
              </el-form-item>
              <el-form-item prop="isdefault">
                  <el-checkbox v-model="form.isdefault">是否设为默认地址</el-checkbox>
              </el-form-item>
              <el-form-item>
                <button type="submit" @click="submitAddress">保存地址</button>
              </el-form-item>
            </el-form>
          </div>
        </el-dialog> -->
    </div>
  </template>
  
  <script>
    import { queryAdress, addAdress, updateAdress, deleteAdress } from "@/api/manage.js";
    import BottomComponent from '../Components/BottomComponent.vue'
    import TopComponent from '@/views/Components/TopComponentcopy.vue'
    import popup from '@/common/plugin/dialog/index.js'
    import addressForm from './addressForm.vue'
    export default {
        props:['changetype', 'addressid'],
      data() {
        return {
            changeType:0,
            addressId:'',
            // newtitle:'新增收货地址',
            // type: 0, //0:新增，1：修改
            // dialogVisible: false,
            addresses: [],
          
        };
      },
      components: {
        BottomComponent,
        TopComponent
      },
      created(){
        let vm = this;
        vm.changeType = vm.changetype;
        vm.addressId = vm.addressid;
      },
      mounted(){
          let vm = this;
          vm.getAddressList();
      },
      methods: {
          getAddressList(){
              let vm = this;
              queryAdress({
                  userid: JSON.parse(localStorage.getItem('user')).gid
              }).then(res => {
                  if(res.status){
                      vm.addresses = res.data;
                      let defaultAddress = '';
                      res.data.forEach((item,index) => {
                        if(item.isdefault == 1){
                            defaultAddress = item.address;
                        }
                      });
                      let userInfo = JSON.parse(localStorage.getItem('user'));
                      userInfo.address = defaultAddress;
                      localStorage.setItem('user', JSON.stringify(userInfo));
                  }
              }).catch(err => {
  
              });
          },
          //选中地址
          chooseThis(data){
            let vm = this;
            if(vm.changeType == '1' && vm.addressId != data.pkid){ //传递的类型参数是1，代表地址可以选择                                  
                vm.$confirm("确定选择这个荐购直邮地址吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {                    
                    vm.$emit('submit', data);
                }).catch(() => {

                });
            }else if(vm.changeType == '0'){ //切换默认地址
                vm.$confirm("确定选择这个为默认地址吗？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    vm.setDefault(data);
                    vm.$emit('submit', data);
                }).catch(() => {

                });
            }
          },
        submitAddress() {
          let vm = this;
          vm.$refs.form.validate(async (valid) => {
            if (valid) {
              let obj = Object.assign({}, vm.form);
              obj.sheng = obj.selectedOptions[0];
              obj.shi = obj.selectedOptions[1];
              obj.qu = obj.selectedOptions[2];
              obj.userid = JSON.parse(localStorage.getItem('user')).gid;
              !obj.isdefault ? obj.isdefault=0 : obj.isdefault=1;
              delete obj.selectedOptions;
              if(vm.type == 0){
                  addAdress(obj).then(res => {
                      if(res.status){   
                          vm.$message({
                              message: "新增收货地址成功！",
                              type: "success"
                          });
                          vm.getAddressList();
                      }
  
                  }).catch(err => {
  
                  }); 
              }else{
                  updateAdress(obj).then(res => {
                      if(res.status){   
                          vm.$message({
                              message: "修改收货地址成功！",
                              type: "success"
                          });
                          vm.getAddressList();
                      }
  
                  }).catch(err => {
  
                  }); 
              }       
            }
          });
        },
        // 新增地址
        addAddress(type, data) {
        //   this.dialogVisible = true;
        //   this.type=0;
            let vm = this;
            vm.edit_pop = popup('<address-form @close="close" @closeall="closeAll" @submit="submit" :type="type" :changetype="changeType" :data="data" />', {
                option: {
                    title: type == 0 ? '新增收货地址' : '修改收货地址',
                    width: '600px'
                },
                popup: {
                    data() {
                        return {
                            type: type, //0：新增地址
                            data: data,
                            changeType: vm.changeType,
                        };
                    },
                    components: {
                        addressForm
                    },
                    methods: {
                        submit(data) {
                            vm.getAddressList();
                            vm.edit_pop.hide();
                        },
                        close(){
                            vm.edit_pop.hide();
                        },
                        closeAll(data){ //关闭所有弹窗
                            vm.$emit('submit', data);
                            vm.edit_pop.hide();
                        }
                    }
                }
            });
            vm.edit_pop.show();
        },
        // 编辑地址
        updateAddress(item) {
          let vm = this;
          vm.addAddress('1', item);
        //   vm.dialogVisible = true;
        //   vm.type=1;
        //   vm.form.username = item.username;
        //   vm.form.mobile = item.mobile;
        //   vm.form.address = item.address;
        //   !item.isdefault ? vm.form.isdefault = false : vm.form.isdefault = true;
        //   vm.form.selectedOptions = [item.sheng, item.shi, item.qu];
        //   vm.form.pkid = item.pkid;
        },
        //设置默认地址
        setDefault(item){
          let vm = this,
              obj = {
                  userid:JSON.parse(localStorage.getItem('user')).gid,
                  pkid:item.pkid,
                  isdefault:1
              };        
          updateAdress(obj).then(res => {
              if(res.status){   
                  vm.$message({
                      message: "设置默认收货地址成功！",
                      type: "success"
                  });
                  let user = JSON.parse(localStorage.getItem('user'));
                  user.address = item.address;
                  localStorage.setItem('user', JSON.stringify(user));
                  vm.getAddressList();
              }
          }).catch(err => {
  
          }); 
        },
        //删除地址
        removeAddress(item) {
          let vm = this;
          vm.$confirm("确定删除此收货地址吗？", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
          }).then(() => {
              deleteAdress({pkid:item.pkid,userid:JSON.parse(localStorage.getItem('user')).gid}).then(res => {
                  if(res.status){        
                      vm.$message({
                          message: "删除成功！",
                          type: "success"
                      });
                      vm.getAddressList();
                  }else{     
                      vm.$message({
                          message: res.errorMsg ||  "删除失败！！",
                          type: "success"
                      });
                  }
              }).catch(err => {
              });
          }).catch(() => {
  
          });
        },
        handleClose(done){   
          let vm = this;
          vm.$confirm('确认关闭？').then(res => {
              vm.$refs['form'].resetFields();
              vm.$refs['form'].clearValidate();
              done();
            }).catch(err => {});
        }
      }
    }
  </script>
  
  <style scoped>
    /* 样式可以根据需求进行修改 */
    .address-management {
      padding: 20px;  
      background-color: #fff;
    }
  
    .addresslist{
      width: 98%; min-height: 100px;padding:10px; border: 2px dashed #e5e5e5; position: relative; margin-bottom: 5px;
    }
    .isDefault{
        background-color:#ff8800;color:#fff;padding:3px 6px;border-radius:4px;position:absolute;top:10px;right:10px;
    }
    .curChange{
        border-color:#ffac30;
        background-color: #fffef7;
    }
    .isChange{
        cursor: pointer;
    }
    .curChange .isDefault{
        background-color:#d3d3d3;
    }
    .isChange:hover{
        border-color:#8fc9ff;
        background-color: #dbebf5;
    }
    .address-form {
      max-width: 400px;
      margin: auto;
    }
  
    .address-form label {
      display: block;
      margin-bottom: 5px;
    }
  
    .address-form select,
    .address-form textarea {
      width: 100%;
      padding: 8px;
      margin-bottom: 10px;
      border-radius: 5px;
      border: 1px solid #ccc;
    }
  
    .address-form button {
      padding: 10px 20px;
      background-color: #007bff;
      color: #fff;
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
  
    .address-form button:hover {
      background-color: #0056b3;
    }
    .semoren:hover{
      cursor: pointer;
      color: brown;
    }
    .bianji:hover{
      cursor: pointer;
      color: brown;
    }
  </style>


// WEBPACK FOOTER //
// src/views/Components/addressManage.vue